import { render } from "./InvoiceModal.vue?vue&type=template&id=ddfb5832&scoped=true"
import script from "./InvoiceModal.vue?vue&type=script&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&lang=js"

import "./InvoiceModal.vue?vue&type=style&index=0&id=ddfb5832&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddfb5832"]])

export default __exports__